import { darken } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { theme } from '../theme';
import { isReactElement } from '../utils/isReactElement';
const styles = {
    info: {
        iconColor: 'liquorice',
        backgroundColor: theme.colors.oatmeal,
        hoverBackgroundColor: darken(0.1, theme.colors.oatmeal),
        icon: 'info',
    },
    fallbackStyle: {
        iconColor: 'liquorice',
        backgroundColor: theme.colors.coconut,
        hoverBackgroundColor: darken(0.1, theme.colors.coconut),
        icon: 'info',
    },
    alert: {
        iconColor: 'tangerine',
        backgroundColor: theme.colors.sherbert,
        hoverBackgroundColor: darken(0.1, theme.colors.sherbert),
        icon: 'alert',
    },
    warning: {
        iconColor: 'strawberry',
        backgroundColor: theme.colors.watermelon,
        hoverBackgroundColor: darken(0.1, theme.colors.watermelon),
        icon: 'warning',
    },
    success: {
        iconColor: 'apple',
        backgroundColor: theme.colors.mint,
        hoverBackgroundColor: darken(0.1, theme.colors.mint),
        icon: 'circle-tick',
    },
};
export const SupportMessage = ({ className, description, onClick, rightSideComponent, type, title, ...marginProps }) => {
    return (React.createElement(Wrapper, { className: className, "$type": type, onClick: onClick, ...marginProps },
        React.createElement(IconWrapper, { alignItems: "center" },
            React.createElement(Icon, { size: 20, render: styles[type].icon, color: styles[type].iconColor })),
        React.createElement(Box, { flex: true, direction: "column", mx: "8px" },
            title && React.createElement(Title, null, title),
            isReactElement(description) ? (React.createElement(DescriptionBox, null, description)) : (React.createElement(Description, { tag: "p" }, description))),
        rightSideComponent,
        onClick && rightSideComponent === undefined && (React.createElement(Box, { ml: { custom: 'auto' } },
            React.createElement(Icon, { size: 16, render: "caret", color: "marzipan", rotate: 270 })))));
};
const IconWrapper = styled(Box) `
  align-self: flex-start;
`;
const Wrapper = styled(Box)(({ $type, onClick }) => css `
    align-items: center;
    background-color: ${styles[$type].backgroundColor};
    border-radius: 16px;
    ${onClick && `cursor: pointer`};
    padding: 12px;
    display: flex;
    width: 100%;

    &:hover,
    &:active {
      ${onClick && `background-color: ${styles[$type].hoverBackgroundColor};`};
    }
  `);
const Title = styled.p `
  font-size: 16px;
  font-weight: ${theme.font.weight.medium};
  color: ${theme.colors.liquorice};
  line-height: 20.8px;
  margin-bottom: 4px;
`;
const DescriptionBox = styled(Box) `
  color: ${theme.colors.liquorice};
  font-size: 14px;
  line-height: 20px;
`;
const Description = styled(Text) `
  color: ${theme.colors.liquorice};
  font-size: 14px;
  line-height: 20px;
`;
//# sourceMappingURL=SupportMessage.js.map